// Traduções específicas para a página de consignação - Português (Brasil)
export const consignmentsPt = {
  hero: {
    title: 'Consignação',
    description:
      'Deixe seu veículo em consignação com a gente e aproveite ao máximo. Cuidamos de todo o processo de venda.',
  },
  form: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    brand: 'Marca',
    brandPlaceholder: 'Selecione uma marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecione um modelo',
    year: 'Ano',
    mileage: 'Quilometragem',
    condition: 'Condição do Veículo',
    message: 'Detalhes adicionais',
    submit: 'Enviar Solicitação',
  },
  info: {
    advantagesTitle: 'Vantagens de Consignar com a Gente',
    benefitsTitle: 'Benefícios da consignação',
    benefitsList: {
      item1: 'Maximize o valor de venda do seu veículo',
      item2: 'Você não precisa se preocupar com o processo de venda',
      item3: 'Ampla exposição a potenciais compradores',
      item4: 'Evite burocracia e trâmites complicados',
    },
    processTitle: 'Processo de consignação',
    processList: {
      step1: 'Avaliação do veículo',
      step2: 'Assinatura do contrato de consignação',
      step3: 'Exposição e divulgação',
      step4: 'Gestão de propostas e negociações',
      step5: 'Pagamento rápido após a venda',
    },
    directContactTitle: 'Contato Direto',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
  },
  embed: {
    infoTitle: 'Como funciona?',
    steps: [
      { title: 'Envie seus dados', desc: 'Preencha o formulário com as informações do seu veículo.' },
      { title: 'Avaliação', desc: 'Nossa equipe avalia seu veículo e entra em contato com você.' },
      { title: 'Anúncio', desc: 'Anunciamos seu veículo em várias plataformas.' },
      { title: 'Venda', desc: 'Cuidamos de todo o processo até fechar a venda.' },
    ],
    benefitsTitle: 'Benefícios',
    benefits: ['Anúncio em várias plataformas', 'Gestão completa da venda', 'Melhor preço garantido'],
  },
};
